import Axios from "../../../Axios/Axios";
import { Urls } from "../../../Urls";

export const exportVehicleAllocationTable = async ({
  startDate,
  endDate,
  plant,
  destination,
  transporterId,
  role,
}) => {
  const params = new URLSearchParams({ start_date: startDate, end_date: endDate });
  if (plant && plant !== "All") params.append("plant", plant);
  if (destination && destination !== "All") params.append("destination", destination);
  if (transporterId && transporterId !== "All") params.append("transporter_id", transporterId);
  if (role) params.append("role", role);
  params.append("skip", 0);
  params.append("limit", 1000);

  const { data } = await Axios.get(`${Urls.tmsDashboardVehicleAllocationExport}?${params.toString()}`);
  return data;
};
